import * as React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import * as colors from '../../shared/colors';
import t from '../../shared/translations';

const Nav = styled.nav`
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-bottom: 0.5rem;

    & a {
        flex-grow: 1;
        flex-shrink: 1;
        text-align: center;
        padding: 0.5rem;
        display: block;
        border: 1px solid ${colors.primaryColor};
        border-right: none;
    }

    a.active {
        background-color: ${colors.primaryColor};
        color: white;
    }

    & a:last-child {
        border-right: 1px solid ${colors.primaryColor};
        border-top-right-radius: 0.3rem;
        border-bottom-right-radius: 0.3rem;
    }

    & a:first-child {
        border-top-left-radius: 0.3rem;
        border-bottom-left-radius: 0.3rem;
    }
`;

function NavBar(): JSX.Element {
    return <>
        <Nav>
            <NavLink to='../messages/inbox'>
                {t('player.messages.link-inbox')}
            </NavLink>
            <NavLink to='../messages/archived'>
                {t('player.messages.link-archived')}
            </NavLink>
            <NavLink to='../messages/sent'>
                {t('player.messages.link-sent')}
            </NavLink>
        </Nav>
    </>;
}

export default NavBar;